<template>
  <md-dialog
    md-open-from="#inicia_processo"
    md-close-to="#inicia_processo"
    ref="upload_planta_dialog"
  >
    <md-dialog-title>{{ title }}</md-dialog-title>
    <md-dialog-content>
      <md-input-container>
        <label>Selecione uma imagem</label>
        <md-file
          accept="image/*"
          @selected="onBluePrintSelected"
        ></md-file>
      </md-input-container>
      <md-spinner
        v-if="isLoading"
        md-indeterminate
        class="loading"
      ></md-spinner>
      <div v-else>
        <md-image
          v-show="previewSrc"
          :md-src="previewSrc"
          @load="revokeURL"
          ref="imagePreview"
        ></md-image>
      </div>

    </md-dialog-content>
    <md-dialog-actions>
      <md-button
        class="md-primary"
        @click="closeDialog"
      >Cancelar
      </md-button>
      <md-button
        class="md-primary"
        @click="confirmSelectedBlueprint"
      >Prosseguir
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'blueprint-dialog',
  props: ['imageId', 'title', 'blueprintUrl'],
  data: () => ({
    previewSrc: '',
    imgBlob: null,
    isLoading: false,
    imgW: 0,
    imgH: 0
  }),
  methods: {
    ...mapActions([
      'FETCH_IMAGE'
    ]),
    onBluePrintSelected (fileList) {
      this.isLoading = true
      var vm = this
      if (fileList && fileList[0]) {
        let img = new Image()
        img.onload = () => {
          vm.imgW = img.width
          vm.imgH = img.height
          vm.previewSrc = img.src
        }
        vm.isLoading = false
        vm.imgBlob = fileList[0]
        img.src = window.URL.createObjectURL(fileList[0])
      }
    },
    confirmSelectedBlueprint () {
      this.$emit('select', this.imgBlob, this.imgW, this.imgH)
      this.imgBlob = null
      this.previewSrc = null
      this.closeDialog()
    },
    revokeURL () {
      URL.revokeObjectURL(this.previewSrc)
    },
    loadImage () {
      this.isLoading = false
      this.previewSrc = URL.createObjectURL(this.imgBlob)
    },
    closeDialog () {
      if (this.previewSrc) {
        this.imgBlob = null
        this.previewSrc = null
      }
      URL.revokeObjectURL(this.previewSrc)
      this.$refs['upload_planta_dialog'].close()
    },
    openDialog () {
      // console.log(this.blueprintUrl)
      // if (this.blueprintUrl) {
      //   this.isLoading = false
      //   this.previewSrc = this.blueprintUrl
      //   this.$refs['upload_planta_dialog'].open()
      // } else {
      if (this.imageId) {
        this.isLoading = true
        this.previewSrc = ''
        this.FETCH_IMAGE(this.imageId).then(imageBlob => {
          this.imgBlob = imageBlob
          this.loadImage()
        }).catch(() => {
          this.isLoading = false
        })
      } else {
        this.previewSrc = ''
      }
      this.$refs['upload_planta_dialog'].open()
      // }
    }
  }
}
</script>
<style scoped>
.loading {
  left: calc(50% - 25px);
}

.md-dialog-title {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// BlueprintDialog.vue?60d98105